import AboutUsSection from "../../components/aboutUs/AboutUsSection";
import HeroCarousel from "../../components/heroCarousel/HeroCarousel";
import ServiceSection from "../../components/services/ServiceSection";
// import Statistics from "../../components/statistics/Statistics";
import SloganSection from "../../components/sloganSection/SloganSection";
import ContactFormSection from "./contactFormSection/ContactFormSection";
// import ProjectsSection from "./projectsSection/ProjectsSection";
import ReviewsTestimonialsSection from "./reviewsTestimonialsSection/ReviewsTestimonialsSection";
import SEO from "../../components/common/SEO";

export function Home() {
  return (
    <div>
      <SEO
        title="Home"
        description="VR Builders & Promoters - Your trusted partner for house planning, approval, and construction in Chennai."
        url="/"
      />
      <HeroCarousel />
      {/* <Statistics /> */}
      <SloganSection />
      <AboutUsSection />
      <ServiceSection />
      {/* <ProjectsSection /> */}
      <ReviewsTestimonialsSection />
      <ContactFormSection />
    </div>
  );
}
